module.exports = __webpack_public_path__ + "static/ss2.31667357.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss2.png
// module id = 1165
// module chunks = 112875127094159